import './FrontC.sass';
import moment from 'moment';
import Slider from 'react-slick';
import { useArticles } from '../api';
import { useMemo, useState } from 'react';

import Hero from '../components/Hero';
import Breadcrumbs from '../components/Breadcrumbs';
import Pagination from '../components/Pagination';
import getTimestamp from '../library/tools/getTimestamp';

import iconPDF from '../assets/common/pdf.svg';
import { Link, useLocation, Redirect } from 'react-router-dom';
import Meta from '../components/Meta';

// import { sortBy } from 'underscore';

const Prev = (props) => {
	return <div className='nav prev' onClick={props.onClick} />;
};

const Next = (props) => {
	return <div className='nav next' onClick={props.onClick} />;
};

const FrontC = (props) => {
	const { routeData } = props;
	const location = useLocation();
	const { pathname } = location;
	const { route } = routeData;
	const [currentPage, setCurrentPage] = useState(1);
	const { articles, totalPage, breadcrumbs } = useArticles(routeData.guid, route, 10, currentPage, '');

	const sortedArticles = useMemo(() => {
		const newArray = [];

		for (let index = 0; index < articles.length; index++) {
			const article = articles[index];
			if (article.value01 === 1) {
				newArray.push(article);
			}
		}

		for (let index = 0; index < articles.length; index++) {
			const article = articles[index];
			if (article.value01 !== 1) {
				newArray.push(article);
			}
		}

		return newArray;
	}, [articles]);

	const parent = useMemo(() => {
		if (routeData.depth === 1) return routeData;
		return routeData.parent;
	}, [routeData]);

	const tabSlidesSettings = useMemo(() => {
		return {
			prevArrow: <Prev />,
			nextArrow: <Next />,
			responsive: [
				{
					breakpoint: 9999,
					settings: 'unslick',
				},
				{
					breakpoint: 767,
					settings: {
						arrows: true,
						dots: false,
						autoplay: false,
						variableWidth: true,
						slidesToShow: 3,
						infinite: false,
					},
				},
			],
		};
	}, []);

	if (routeData.depth === 1) {
		return <Redirect to={routeData.categoryChild?.[0]?.route} />;
	}

	return (
		<div className='FrontC min-page-height'>
			<Meta data={routeData} />
			<Hero data={breadcrumbs} />
			<Breadcrumbs data={breadcrumbs} />

			<div className='common-pad-wrap'>
				<div className='page-content'>
					<div className='tab-headings'>
						<Slider {...tabSlidesSettings} className='slider'>
							{/* <Link to={parent.route} className={`tab ${pathname === parent.route && 'active'}`}>
								<div className='mid-wrap'>
									<div className='text'>全部</div>
									<div className='border'></div>
								</div>
							</Link> */}

							{parent.categoryChild.map((tab) => {
								return (
									<Link to={tab.route} className={`tab ${pathname === tab.route && 'active'}`} key={tab.guid}>
										<div className='mid-wrap'>
											<div className='text'>{tab.name}</div>
											<div className='border'></div>
										</div>
									</Link>
								);
							})}
						</Slider>
					</div>

					<div className='tab-content'>
						{sortedArticles.map((article) => {
							const { title, postTime, files, url, guid, value01 } = article;
							const timestamp = getTimestamp(postTime);
							const date = moment(timestamp).format('YYYY/MM/DD');

							if (url) {
								return (
									<a href={url} target='_blank' rel='noreferrer noopener' className='article' key={guid}>
										<div className='left'>
											<div className='title'>{title}</div>
											<div className='bot-flex'>
												{value01 ? null : (<div className='date'>{date}</div>)}

												<div className='tag'>{routeData.name}</div>
											</div>
										</div>

										{files ? (
											<div className='right'>
												<div className='icon'>
													<img src={iconPDF} alt='PDF' />
												</div>
											</div>
										) : null}
									</a>
								);
							}

							return (
								<Link to={`${routeData.route}/${guid}`} className='article' key={guid}>
									<div className='left'>
										<div className='title'>{title}</div>
										<div className='bot-flex'>
											<div className='date'>{date}</div>
											<div className='tag'>{routeData.name}</div>
										</div>
									</div>

									{files ? (
										<div className='right'>
											<div className='icon'>
												<img src={iconPDF} alt='PDF' />
											</div>
										</div>
									) : null}
								</Link>
							);
						})}
					</div>
				</div>
			</div>

			<Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPage={totalPage} />
		</div>
	);
};

export default FrontC;
